// Gradient background options matching the Flutter app
export const backgroundOptions = [
  // Option 0: Current default background (purple/blue gradient)
  [
    '#533483',
    '#1A1A2E',
    '#16213E',
    '#0F3460',
  ],
  // Option 1: Warm sunset gradient (orange/red/pink)
  [
    '#FF6B35',
    '#F7931E',
    '#E74C3C',
    '#C0392B',
  ],
  // Option 2: Cool ocean gradient (teal/blue/cyan)
  [
    '#1ABC9C',
    '#16A085',
    '#3498DB',
    '#2980B9',
  ],
];

export const getBackgroundColors = (index: number): string[] => {
  if (index >= 0 && index < backgroundOptions.length) {
    return backgroundOptions[index];
  }
  return backgroundOptions[0]; // Default to first option if invalid index
};

export const backgroundOptionCount = backgroundOptions.length;
